import type { Nullable } from '@iheartjane/types';
import type { Location } from 'react-router';

/**
 * Create a canonical link for use in a `meta` function.
 * @see https://remix.run/docs/en/main/route/meta
 * @see https://developers.google.com/search/docs/crawling-indexing/consolidate-duplicate-urls
 */
export function canonicalTag(location: Location, menuUrl?: Nullable<string>) {
  const origin = menuUrl ? new URL(menuUrl).origin : '';
  return {
    href: `${origin}${location.pathname}`,
    rel: 'canonical',
    tagName: 'link',
  };
}
